<template>
  <div id="app" v-wechat-title="$route.meta.title">
    <router-view id="app-view"></router-view>
    <img
        src="@/assets/baohanmsg.png"
        alt=""
        class="baohanImg"
      />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      loading: "",
      loadingend: ""
    };
  },
  mounted() {
    var odiv = document.querySelector("body");
    odiv.style.cssText = "background-color:#FAFBFC;" + "min-width:1200px";
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {}
};
</script>

<style lang="less">
#app{
  position: relative;
  overflow   : scroll;
  height: 100%;
  &-view{
    height: 100%;
  }
}
.stepbtn {
  width: 108px;
}

#layui-layer1 {
  z-index: 200 !important;
  display: none;
}
.layui-layer-shade {
  z-index: 190 !important;
  display: none;
}
.cursor {
  cursor: pointer;
}
.clear {
  clear: both;
}
.overflow {
  overflow: hidden;
}
.left {
  float: left;
}
.right {
  float: right;
}
.layui-icon-right {
  position: absolute;
  left: 50%;
}
.step-item-tail i {
  background: none;
}
.lay-step {
  height: 88px;
  line-height: 88px;
  background: #fafbfc;
  padding-left: 0;
  border-bottom: 1px solid #e1e8ec;
}
.layui-fluid {
  padding: 0;
}
.layui-card-body {
  padding: 0;
}
.step-item {
  height: 100%;
}
.step-item {
  left: 17%;
  top: 21%;
}
.layui-input,
.layui-textarea {
  font-size: 12px;
}
.layui-form-select dl dd {
  font-size: 12px;
}
.layui-text ul li {
  list-style: none;
}
.layui-btn {
  background: #19aecf;
  border-radius: 4px;
}
.layui-btn-primary {
  background: #ffffff;
}

.baohanImg {
  width: 168px;
  height: 394px;
  position: absolute;
  right: 0px;
  top: 400px;
  z-index: 1;
}
</style>
